export interface DocumentAssetReference {
  assetId: string;
  version: number;
  sha256: string;
}
export interface DocumentBrandReference {
  brandId: string;
  version: number;
  sha256: string;
}
export interface DocumentBrandStyle {
  fontCode: string;
  fontSha256: string;
  logo: DocumentAssetReference | null;
  logoWidthPt: number;
  logoHeightPt: number;
  logoAlignment: 'start' | 'center' | 'end';
  accentColor: string;
  watermarkText: string;
  watermarkColor: string;
  watermarkOpacity: number;
  watermarkRotation: number;
}
export interface DocumentAssetVersion {
  reference: DocumentAssetReference;
  name: string;
  alternativeText: string;
  fileName: string;
  contentType: string;
  widthPx: number;
  heightPx: number;
  length: number;
  scopeTypeCode: string;
  scopeKey: string | null;
  createdUtc: string;
  isLatest: boolean;
  usageCount: number;
}
export interface DocumentBrandVersion {
  reference: DocumentBrandReference;
  name: string;
  scopeTypeCode: string;
  scopeKey: string | null;
  style: DocumentBrandStyle;
  createdUtc: string;
  isLatest: boolean;
  usageCount: number;
}
export interface DocumentAssetScope {
  scopeTypeCode: string;
  scopeKey: string | null;
  label: string;
}
export interface DocumentAssetCatalog {
  items: DocumentAssetVersion[];
  brands: DocumentBrandVersion[];
  scopes: DocumentAssetScope[];
  canUpload: boolean;
  canSelect: boolean;
  fonts: { code: string; label: string; sha256: string; available: boolean }[];
  limits: {
    maxBytes: number;
    maxWidthPx: number;
    maxHeightPx: number;
    maxPixels: number;
  };
  scopeTypeCode: string | null;
  scopeKey: string | null;
  unsupported: string[];
}
export interface DocumentAssetUploadRequest {
  requestId: string;
  assetId: string | null;
  expectedVersion: number | null;
  scopeTypeCode: string;
  scopeKey: string | null;
  name: string;
  alternativeText: string;
  fileName: string;
  contentType: string;
  bytesBase64: string;
}
export interface DocumentBrandSaveRequest {
  requestId: string;
  brandId: string | null;
  expectedVersion: number | null;
  scopeTypeCode: string;
  scopeKey: string | null;
  name: string;
  style: DocumentBrandStyle;
}
export function sameAssetReference(
  a: DocumentAssetReference | null | undefined,
  b: DocumentAssetReference | null | undefined,
): boolean {
  return (
    !!a &&
    !!b &&
    a.assetId === b.assetId &&
    a.version === b.version &&
    a.sha256 === b.sha256
  );
}
export function sameBrandReference(
  a: DocumentBrandReference | null | undefined,
  b: DocumentBrandReference | null | undefined,
): boolean {
  return (
    !!a &&
    !!b &&
    a.brandId === b.brandId &&
    a.version === b.version &&
    a.sha256 === b.sha256
  );
}

export interface DocumentAssetManifest {
  contractCode: string;
  version: number;
  reference: DocumentBrandReference;
  name: string;
  style: DocumentBrandStyle;
  assets: {
    reference: DocumentAssetReference;
    name: string;
    alternativeText: string;
    fileName: string;
    contentType: string;
    widthPx: number;
    heightPx: number;
    bytesBase64: string;
  }[];
}
